<template>
  <el-dialog 
    :visible.sync="dialogVisible" 
    :title="isEdit ? '编辑通行组配置' : '新增通行组配置'" 
    width="600px"
    @close="handleClose"
  >
    <el-form ref="configForm" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="通行组名称" prop="groupName">
        <el-input v-model="form.groupName" placeholder="请输入通行组名称" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      
      <el-form-item label="免费日期" prop="freeDays">
        <el-checkbox-group v-model="form.freeDaysArray" @change="handleFreeDaysChange">
          <el-checkbox label="1">周一</el-checkbox>
          <el-checkbox label="2">周二</el-checkbox>
          <el-checkbox label="3">周三</el-checkbox>
          <el-checkbox label="4">周四</el-checkbox>
          <el-checkbox label="5">周五</el-checkbox>
          <el-checkbox label="6">周六</el-checkbox>
          <el-checkbox label="7">周日</el-checkbox>
        </el-checkbox-group>
        <div style="color: #999; font-size: 12px; margin-top: 5px;">选择免费的星期几（与收费日期互斥）</div>
      </el-form-item>
      
      <el-form-item label="收费日期" prop="chargeDays">
        <el-checkbox-group v-model="form.chargeDaysArray" @change="handleChargeDaysChange">
          <el-checkbox label="1">周一</el-checkbox>
          <el-checkbox label="2">周二</el-checkbox>
          <el-checkbox label="3">周三</el-checkbox>
          <el-checkbox label="4">周四</el-checkbox>
          <el-checkbox label="5">周五</el-checkbox>
          <el-checkbox label="6">周六</el-checkbox>
          <el-checkbox label="7">周日</el-checkbox>
        </el-checkbox-group>
        <div style="color: #999; font-size: 12px; margin-top: 5px;">选择收费的星期几（与免费日期互斥）</div>
      </el-form-item>
      
      <el-form-item label="描述说明" prop="description">
        <el-input 
          v-model="form.description" 
          type="textarea" 
          :rows="3" 
          placeholder="请输入描述说明"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
      
      <el-form-item label="是否启用" prop="isActive">
        <el-radio-group v-model="form.isActive">
          <el-radio :label="true">启用</el-radio>
          <el-radio :label="false">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addVehicleGroupConfig, updateVehicleGroupConfig } from './api'

export default {
  name: 'ConfigForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    configData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      form: {
        id: null,
        groupName: '',
        freeDaysArray: [],
        chargeDaysArray: [],
        description: '',
        isActive: true
      },
      rules: {
        groupName: [
          { required: true, message: '请输入通行组名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        freeDays: [
          { 
            validator: (rule, value, callback) => {
              const totalDays = new Set([...this.form.freeDaysArray, ...this.form.chargeDaysArray])
              if (totalDays.size !== 7) {
                callback(new Error('必须为每一天设置免费或收费状态'))
              } else {
                callback()
              }
            }, 
            trigger: 'change' 
          }
        ]
      }
    }
  },
  computed: {
    isEdit() {
      return !!this.form.id
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.initForm()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    initForm() {
      if (this.configData && this.configData.id) {
        // 编辑模式
        this.form = {
          id: this.configData.id,
          groupName: this.configData.groupName || '',
          freeDaysArray: this.configData.freeDays ? this.configData.freeDays.split(',') : [],
          chargeDaysArray: this.configData.chargeDays ? this.configData.chargeDays.split(',') : [],
          description: this.configData.description || '',
          isActive: this.configData.isActive === true || this.configData.isActive === 1
        }
      } else {
        // 新增模式
        this.form = {
          id: null,
          groupName: '',
          freeDaysArray: [],
          chargeDaysArray: [],
          description: '',
          isActive: true
        }
      }
      this.$nextTick(() => {
        this.$refs.configForm && this.$refs.configForm.clearValidate()
      })
    },
    
    handleSubmit() {
      this.$refs.configForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          
          // 将数组转换为逗号分隔的字符串
          const submitData = {
            ...this.form,
            freeDays: this.form.freeDaysArray.join(','),
            chargeDays: this.form.chargeDaysArray.join(',')
          }
          delete submitData.freeDaysArray
          delete submitData.chargeDaysArray
          
          const apiCall = this.isEdit 
            ? updateVehicleGroupConfig(submitData)
            : addVehicleGroupConfig(submitData)
          
          apiCall.then(res => {
            if (res.data.code === 20000) {
              this.$message.success(this.isEdit ? '修改成功' : '添加成功')
              this.dialogVisible = false
              this.$emit('success')
            } else {
              this.$message.error(res.data.message || '操作失败')
            }
          }).catch(err => {
            console.error(err)
            this.$message.error('操作失败，请稍后重试')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    
    handleClose() {
      this.$refs.configForm && this.$refs.configForm.resetFields()
    },
    
    /**
     * 处理免费日期变化 - 实现互斥
     */
    handleFreeDaysChange(value) {
      // 获取所有天数 1-7
      const allDays = ['1', '2', '3', '4', '5', '6', '7']
      
      // 收费日期 = 所有天数 - 免费日期
      this.form.chargeDaysArray = allDays.filter(day => !value.includes(day))
      
      // 触发表单验证
      this.$nextTick(() => {
        this.$refs.configForm && this.$refs.configForm.validateField('freeDays')
      })
    },
    
    /**
     * 处理收费日期变化 - 实现互斥
     */
    handleChargeDaysChange(value) {
      // 获取所有天数 1-7
      const allDays = ['1', '2', '3', '4', '5', '6', '7']
      
      // 免费日期 = 所有天数 - 收费日期
      this.form.freeDaysArray = allDays.filter(day => !value.includes(day))
      
      // 触发表单验证
      this.$nextTick(() => {
        this.$refs.configForm && this.$refs.configForm.validateField('freeDays')
      })
    }
  }
}
</script>

<style scoped>
</style>
